export default __webpack_public_path__ + "static/media/app-download-bg.26188cf7.png";